var render, staticRenderFns
import script from "./shopHome.vue?vue&type=script&lang=js"
export * from "./shopHome.vue?vue&type=script&lang=js"
import style0 from "./shopHome.vue?vue&type=style&index=0&id=b055290a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b055290a",
  null
  
)

export default component.exports